import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/pro-solid-svg-icons/faArrowTrendUp';
import { faArrowTrendDown } from '@fortawesome/pro-solid-svg-icons/faArrowTrendDown';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { colorPalette } from 'shared/constants';
import { TREND_STATUS } from 'shared/constants/quality-metric.constants';
import { formatTrendPeriod } from 'shared/utils/quality-metrics.utils';
import { Tooltip } from 'src/components/core';
import styles from './trend-indicator.module.scss';
import { faDash } from '@fortawesome/pro-solid-svg-icons';

const STATUS_CONFIG = {
  [TREND_STATUS.NO_CHANGE]: { icon: faDash, getLabel: () => '0%' },
  [TREND_STATUS.UP]: { icon: faArrowTrendUp, getLabel: delta => `+${delta}%` },
  [TREND_STATUS.DOWN]: { icon: faArrowTrendDown, getLabel: delta => `${delta}%` },
};

export function TrendIndicator({ trend }) {
  const lang = useSelector(getLang('QUALITY_METRIC'));

  const config = trend && STATUS_CONFIG[trend.status];
  if (!config) return null;

  const tooltipTitle =
    trend?.comparisonMonth && trend?.currentMonth
      ? lang.TREND_TOOLTIP.replace(
          '{previousPeriod}',
          formatTrendPeriod(trend?.comparisonMonth, trend?.comparisonYear),
        ).replace('{currentPeriod}', formatTrendPeriod(trend?.currentMonth, trend?.currentYear))
      : undefined;

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.2}>
      <div className={styles.trendInline}>
        <p className={styles.trendDelta}>{config.getLabel(trend.delta)}</p>
        <FontAwesomeIcon icon={config.icon} color={colorPalette.neutral1} />
      </div>
    </Tooltip>
  );
}
